app.factory('statusReasonModel', ['$rootScope', 'baseModel', 'statusReasonService',
    function($rootScope, baseModel, statusReasonService) {

	    function StatusReasonModel() {
	
	        this.getList = function(objectType, statusReasonType) {
		   		statusReasonService.getList(objectType, statusReasonType).then(
		   			function (list) {
		   				$rootScope.$broadcast(Event.STATUS_REASON.GET_LIST.SUCCESS, list);
		   			},
		   			function(error) {
		   				$rootScope.$broadcast(Event.STATUS_REASON.GET_LIST.ERROR, error);
		   			}
		   		)
		    };
		    
	    }
	
	    return new StatusReasonModel();
	}
]);
